/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useRoute } from "wouter";
import { z } from "zod";

import { NationalVendorLandingRoute } from "../../navigation/NationalRoutes";
import { getDealerBasePath } from "../../navigation/getDealerBasePath";
import { useSearchForm } from "../../stores/hooks/useSearchForm";
import { PrimaryButton } from "../../ui/Button/Button";
import { useForm } from "../../util/useForm";
import { ChassisInput } from "./inputs/ChassisInput";
import { PostalCodeInput } from "./inputs/PostalCodeInput";

const schema = z.object({
  vehicleChassis: z.string(),
});

export const Chassis: FunctionComponent = () => {
  const { t } = useTranslation();
  const [shouldRenderPostCode] = useRoute(NationalVendorLandingRoute);
  const [{ vehicleChassis }] = useSearchForm();

  const [, setLocation] = useLocation();
  const [handleForm] = useForm({
    onSubmit({ vehicleChassis }) {
      const basePath = getDealerBasePath();
      if (!basePath) {
        return;
      }
      const nextPath = `${basePath}/product/TIRES/type/chassis-search/chassis/${encodeURIComponent(
        vehicleChassis
      )}`;

      setLocation(nextPath);
    },
    schema,
  });
  return (
    <form
      className={clsx(
        "grid lg:flex gap-2",
        shouldRenderPostCode && "sm:grid-cols-2"
      )}
      noValidate
      onSubmit={handleForm}
    >
      <ChassisInput />
      {shouldRenderPostCode && <PostalCodeInput />}
      <PrimaryButton
        aria-label="viewResults"
        className="shrink-0 shadow-lg sm:col-span-2 h-12 md:h-14"
        disabled={!vehicleChassis}
        type="submit"
      >
        {t("searchForm.viewResults")}
      </PrimaryButton>
    </form>
  );
};
